export default "__VITE_ASSET__BlALLYjW__"